import React from 'react'
import { RenderAnonymous, RenderAuthenticated } from "@seims/shared/src/security";
import CandidateDetailsView from './CandidateDetailsView';
import { NysLandingView } from './NYSLandingView';

export const NYSView = () => {

  return (
    <>
      <RenderAuthenticated>
        <CandidateDetailsView />
      </RenderAuthenticated>

      <RenderAnonymous>
        <NysLandingView />
      </RenderAnonymous>

    </>
  );
}
